(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Layer_Shapefile_Polygon = (function(superClass) {
    extend(Layer_Shapefile_Polygon, superClass);

    function Layer_Shapefile_Polygon() {
      Layer_Shapefile_Polygon.__super__.constructor.call(this);
      this.layoutSelector = null;
    }

    Layer_Shapefile_Polygon.prototype.init = function() {
      var id;
      id = this.loadLayoutPostOptions.id;
      this.overlay = new geoXML3.parser({
        map: App.map,
        processStyles: true,
        singleInfoWindow: true,
        infoWindowOptions: {
          disableAutoPan: true
        },
        afterParse: function(doc) {
          var i, len, p, ref, results;
          ref = doc[0]['gpolygons'];
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            p = ref[i];
            results.push(p['fillOpacity'] = 0.65);
          }
          return results;
        }
      });
      return this.overlay.parse("layers/shapefile/get-kml?id=" + id);
    };

    Layer_Shapefile_Polygon.prototype.destroy = function() {
      if (this.overlay) {
        return this.overlay.hideDocument();
      }
    };

    return Layer_Shapefile_Polygon;

  })(Handler);

}).call(this);
